import base from 'Assets/sass/base';
import * as components from './components/components';
import * as modules from './modules/modules';

// Polyfill
import elementClosest from 'element-closest';
elementClosest(window); // this is used to reference window.Element

// Components Life Cycle
const lifeCycle = (behaviors: any): void => {

  if(typeof behaviors === 'object'){
    for(const[namespace, datas] of Object.entries(behaviors)){
      lifeCycle(datas);
    }
  }

  if(typeof behaviors === 'function') {
    if(typeof Drupal === 'undefined') {
      behaviors();
    }
    else {
      const randId: string = Math.floor(Math.random() * 100000000).toString(16);
      Drupal.behaviors[randId] = {
        attach: behaviors,
      };
    }
  }
};
lifeCycle(components);
lifeCycle(modules);

export {
  base,
  components,
  modules,
};
